import { Tooltip} from "@material-tailwind/react";
import { useMemo } from "react";
import { useRef } from "react";

const DisplayTrackMP= ({ currentTrack }) => {
  console.log(currentTrack, "displaytrackmp")
  const frames = [ { color: "red" },
  { transform: "scale(1.05)", color: "red" },
  { transform: "translateY(-10%)", color: "red" }, 
  { transform: "translateY(-30%)" , color: "red"}, 
  { transform: "scale(1.2)" , color: "red"},
  { transform: "translateY(-10%)" , color: "red"},
  { transform: "translateY(0%)" , color: "red"}, 
  { transform: "scale(1.2)", color: "red" },
  { transform: "scale(1.0)" , color: "inherit"},
  ]
  const inputRef_0 = useRef(null);
  const inputRef_1 = useRef(null);


 
  let audio_0 = useMemo(() => new Audio(currentTrack[0].audio))
  let audio_1 = useMemo(() => new Audio(currentTrack[1].audio))
  console.log(audio_0, audio_0, "audio")
  const Playit_0 = () => {
    audio_0.removeEventListener("ended", FireUp)
    inputRef_0.current&&inputRef_0.current.animate(  
      frames,{ duration: audio_0.duration*1000 , fill: "forwards", iterations: 1 } 
    );
    audio_0.play();
  };

  const Playit_1 = () => {
    inputRef_1.current&&inputRef_1.current.animate(  
      frames ,{ duration: audio_1.duration*1000 , fill: "forwards", iterations: 1 } 
        );
    audio_1.play();
  };

  const FireUp = () => {
    setTimeout(() => {
      inputRef_1.current&&inputRef_1.current.animate(  
          frames ,{ duration: audio_1.duration*1000 , fill: "forwards", iterations: 1 } 
            );
      audio_1.play();
    }, 300) 
  };

  const  PlayBoth = () => {
    audio_0.addEventListener("ended", FireUp)
    audio_0.currentTime = 0; 
    audio_1.currentTime = 0;
    audio_0.oncanplaythrough = function(){
      setTimeout(() => {
        audio_0.play();
        inputRef_0.current&&inputRef_0.current.animate(  
          frames,{ duration: audio_0.duration*1000 , fill: "forwards", iterations: 1 } 
        );
      }, audio_0.duration) 
      }
    };

  
  return (
    <div className="flex w-full items-center gap-2 rounded-xl border border-slate-200 bg-white p-2">
    
      <Tooltip className="flex flex-col bg-indigo-300 font-medium text-white rounded-full px-3"
            animate={{
              mount: { scale: 1.2, y: 0 },
              unmount: { scale: 0, y: 25 },}} 
            content={currentTrack[0].translation}
      >
          <button className="basis-2/5 rounded-lg bg-transparent px-3 py-2 font-serif text-sm font-semibold text-slate-700 transition hover:bg-cyan-50 hover:text-cyan-900" onClick={Playit_0}>
           {currentTrack[0].word.length < 10  ?
            <p className="text-center" ref={inputRef_0} >{currentTrack[0].word}</p>
            :
            <p className="text-center break-all" ref={inputRef_0} >{currentTrack[0].word}</p>
           }
          </button>
      </Tooltip>

<button aria-label="Play both words" className="basis-1/5 rounded-lg bg-cyan-50 py-3 text-sm font-bold text-cyan-800 transition hover:bg-cyan-100" onClick={PlayBoth}>
       <p className="text-center">&#9654;</p>
      </button>
        
        
      <Tooltip className="flex flex-col bg-indigo-300 font-medium text-left text-white rounded-full px-3"
            animate={{
              mount: { scale: 1.1, y: 0 },
              unmount: { scale: 0, y: 25 },}} 
            content={currentTrack[1].translation}
      > 
          <button className="basis-2/5 rounded-lg bg-transparent px-3 py-2 font-serif text-sm font-semibold text-slate-700 transition hover:bg-cyan-50 hover:text-cyan-900" onClick={Playit_1}>
          {currentTrack[1].word.length < 10  ?
            <p className="text-center" ref={inputRef_1}>{currentTrack[1].word}</p>
            :
            <p className="text-center break-all" ref={inputRef_1}>{currentTrack[1].word}</p>
          }
          </button>
      </Tooltip>
     
      
    </div>
    
  );
};
export default DisplayTrackMP;
